




































import { Component, Prop, Vue } from 'vue-property-decorator'

import { ListItem, VxInputGroup } from '@/layouts/components'

import { ModalState } from '@/models'

import CopyButton from './CopyButton.vue'

@Component({
  components: {
    CopyButton,
    ListItem,
    VxInputGroup
  }
})
export default class ShareQrCodeModal extends Vue {
  @Prop({ type: ModalState, required: true })
  readonly modalState!: ModalState

  @Prop({ type: String, required: true })
  readonly url!: string

  @Prop({ type: String, required: true })
  readonly code!: string
}
